import { HasPermission } from '@shared/components';

import { VehiclesHeader } from '../containers/vehicles-header/vehicles-header';
import { VehiclesTable } from '../containers/vehicles-table/vehicles-table';

export const Vehicles = () => {
  return (
    <HasPermission permissionFeature="VEHICLES" permissionType="READ" redirect>
      <VehiclesHeader />
      <VehiclesTable />
    </HasPermission>
  );
};
